import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { AGENCY_AGENT_LAYOUT_MAX_WIDTH } from '../../../constants';

const { colors, spacing, typography } = tokens;

const TWO_LINE_SPLIT_BREAKPOINT = 935;

export const wrapper = css`
  width: 100%;
  max-width: ${AGENCY_AGENT_LAYOUT_MAX_WIDTH}px;
  margin: 0 auto;
  padding: ${spacing.l} 0 0;
  margin-bottom: ${spacing.m};

  @media (max-width: ${TWO_LINE_SPLIT_BREAKPOINT}px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
`;

export const container = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${TWO_LINE_SPLIT_BREAKPOINT}px) {
    display: contents;
  }
`;

export const heading = css`
  ${applyFont(typography.heading)}
  color: ${colors.neutral.heavy.default};
  line-height: 35px;
  width: 100%;
`;

export const separator = css`
  display: none;
`;

export const ratingsRow = css`
  ${applyFont(typography.body)}
  display: flex;
  align-items: center;
  height: 26px;
  gap: ${spacing.xxs};
  margin-top: ${spacing.xs};
`;

export const pipe = css`
  color: ${colors.neutral.medium.default};
  margin-bottom: 2px;
`;

export const reviewsProvided = css`
  display: flex;
  align-items: center;
  gap: ${spacing.xxs};
  ${applyFont(typography.body)}
  color: ${colors.neutral.heavy.default};
  line-height: 26px;
`;

export const disclaimer = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: ${spacing.xs} 0 0;

  @media (max-width: ${TWO_LINE_SPLIT_BREAKPOINT}px) {
    width: 100%;
    margin-top: ${spacing.xs};
  }
`;
